import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils } from '@shared/utils';
import { PaymentApi } from '@shared/api';

export const generateReceiptByIdEffect = createEffect((id: string) => PaymentApi.getGenerateReceiptById(id));
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(generateReceiptByIdEffect.pending, (_, data) => data)
  .on(generateReceiptByIdEffect.fail, () => false)
  .on(generateReceiptByIdEffect.done, () => false)
  .reset(clearEvent);

generateReceiptByIdEffect.done.watch((result) => FileUtils.downloadFile(result.result, `Deposit Payment Report - ${result.params}`));
generateReceiptByIdEffect.fail.watch(() =>
  $notificationStore.events.setError('Something went wrong while downloading Payment Report. Please try again.'),
);

export const $generateReceiptByIdStore = {
  events: {
    generateReceipt: generateReceiptByIdEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
  }),
};
